package com.solevo.dist.theme.styles

import com.solevo.dist.theme.JsTheme
import com.solevo.dist.util.Id
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val NavigationItemStyle = CssStyle {
    cssRule("") {
        Modifier
            .transition(Transition.of(TransitionProperty.All, 200.ms))
            .styleModifier { property("border-radius", "8px") }
            .padding(12.px)
            .margin(bottom = 4.px)
    }

    cssRule(":hover") {
        Modifier
            .backgroundColor(JsTheme.BlueLight.rgb)
            .styleModifier { property("border-radius", "8px") }
    }

    cssRule(" > #${Id.svgParent} > #${Id.vectorIcon}") {
        Modifier
            .transition(Transition.of(TransitionProperty.All, 300.ms))
            .styleModifier { property("stroke", JsTheme.VeryDarkGray.hex) }
    }

    cssRule(":hover > #${Id.svgParent} > #${Id.vectorIcon}") {
        Modifier
            .transition(Transition.of(TransitionProperty.All, 300.ms))
            .styleModifier { property("stroke", JsTheme.BlueDark.hex) }
    }

    cssRule(" > #${Id.navigationText}") {
        Modifier
            .transition(Transition.of(TransitionProperty.All, 300.ms))
            .color(JsTheme.DarkGray.rgb)
    }

    cssRule(":hover > #${Id.navigationText}") {
        Modifier
            .transition(Transition.of(TransitionProperty.All, 300.ms))
            .color(JsTheme.BlueDark.rgb)
    }
}

val NavigationItemSelectedStyle = CssStyle {
    cssRule("") {
        Modifier
            .backgroundColor(JsTheme.BlueLight.rgb)
            .padding(12.px)
            .styleModifier { property("border-radius", "8px") }
    }

    cssRule(" > #${Id.navigationText}") {
        Modifier.color(JsTheme.BlueDark.rgb)
    }

    cssRule(" > #${Id.svgParent} > #${Id.vectorIcon}") {
        Modifier.styleModifier { property("stroke", JsTheme.BlueDark.hex) }
    }
}